import React from 'react';
import FVHeader from '../components/public/FVHeader';
import Styled from '../styles/public/FerramentaVideoPublic.styled';
import { YellowButton } from 'components/UI/Buttons';
import { useHistory } from 'react-router-dom';
const FVNotFound = () => {
    const history = useHistory();

    const goToSolutions = () => {
        history.push('/solucoes');
    };
    const goToHome = () => {
        history.push('/');
    };

    return (
        <Styled.NotFound.Container>
            <Styled.NotFound.Content>
                <Styled.NotFound.Title>Nenhum conteúdo encontrado!</Styled.NotFound.Title>
                <YellowButton style={{maxWidth: '100%', width: 'fit-content', fontSize: 22, padding: 32}} onClick={goToSolutions}>Acessar as páginas das soluções</YellowButton>
                <YellowButton style={{maxWidth: '100%', width: 'fit-content', fontSize: 22, padding: 32}} onClick={goToHome}>Acessar Home</YellowButton>
            </Styled.NotFound.Content>
        </Styled.NotFound.Container>
    );
};


export default FVNotFound;
